var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('business-profile-page',[_c('business-credit-cards',{attrs:{"business":_vm.currentBusiness},on:{"credit-card-added":function($event){return _vm.$store.dispatch('getBusinessOnboardingItems')}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }